import React from "react";
import { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabWithCount } from "../SocialCase/SocialCase";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import ServiceAccounts from "../../components/PaymentPlanTabs/ServiceAccountTab";
import ConnectionFreePlots from "../../components/PaymentPlanTabs/ConnectionFree";
import Summary from "../../components/PaymentPlanTabs/SummaryTab";
import PlanDetails from "../../components/PaymentPlanTabs/PlanDetails";
import Thankyou from "../../components/SocialCaseTbas/Thankyou";
import { Backdrop } from "@mui/material";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import PaymentPlanStore from "../../stores/PaymentPlanStore";
import General from "../../stores/GeneralStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import AccountPopup from "../../components/PaymentPlanTabs/AccountPopup";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Output } from "./../../components/move-inRegistrationTabs/TenantOwnerDetails";
import { toJS } from "mobx";
import paymentPlan from "../../stores/PaymentPlanStore";
import { useNavigate } from "react-router-dom";
// import CustomErrorToaster from "../../components/ErrorToaster/CustomErrorToaster";
import CustomErrorToaster from "../../../src/components/ErrorToaster/CustomErrorToaster";
import { NotifyError } from "../../utils/ShowError";

interface Obj {
  [key: string]: any;
}

const PaymentPlan = () => {
  const [value, setValue] = useState(0);
  const [openAddAccount, setOpenAddAccount] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [CaseID, setCaseID] = useState<string>("");
  const [accountFound, setAccountFound] = useState<Obj | null>(null);
  const [inputValue, setinputValue] = useState();
  const [serviceLoader,setServiceLoader]=useState(false);
  const [connectorLoader,setConnectorLoader]=useState(false);
  const [submitLoader,setSubmitLoader]=useState(false);

  const id = toJS(paymentPlan?.plan?.output?.caseId);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // setValue(newValue);
    ErrorSubscription.unSubscribeAll();
  };
  const notify = (message: any) =>
    toast.error(<CustomErrorToaster errorMessage={message} />);
  const getServiceAccounts = async () => {
    setServiceLoader(true)
    await PaymentPlanStore.getAdvanceAmountService({
      errorId: "getAdvanceAmountServiceError",
      data: User.info.personId as string,
    });
    setServiceLoader(false);
  };

  const getConnectorAccounts = async () => {
    setConnectorLoader(true);
    await PaymentPlanStore.getAdvanceAmountConnector({
      errorId: "getAdvanceAmountConnectorError",
      data: User.info.personId as string,
    });
    setConnectorLoader(false);
  };

  const handleAddServiceAccount = (account: Obj) => {
    PaymentPlanStore.addServiceAccounts(account);
  };

  const handleRemoveServiceAccount = (accountId: string) => {
    PaymentPlanStore.removeServiceAccounts(accountId);
  };

  const handleAddConnectorAccount = (account: Obj) => {
    PaymentPlanStore.addConnectorAccounts(account);
  };

  const handleRemoveConnectorAccount = (accountId: string) => {
    PaymentPlanStore.removeConnectorAccounts(accountId);
  };

  const handleValidateMakani = async (makaniNumber: string) => {
    const dataWithError = {
      data: makaniNumber,
      errorId: "makaniError",
    };
    const res = await General.validateMakani(dataWithError);
    if (res?.result?.message != "CM_Invalid_Makani_No") {
      notify("Invalid Makani Number");
    }
  };
  const handleAddAccountClose = () => {
    setOpenAddAccount(false);
  };

  // const handleCCVerification = () => {
  //   setOpenAddAccount(false);
  //   setLoading(false);
  // };

  const handleOpenAddAccountModal = () => {
    setOpenAddAccount(true);
  };

  const handleSearchAccountNumber = (accountNumber: string) => {
    const serviceSearch = PaymentPlanStore.serviceAccounts.find(
      (account) => account.accountId == accountNumber
    );
    if (serviceSearch) {
      setAccountFound({ ...serviceSearch, type: "s" });
      return;
    }

    const connectorSearch = PaymentPlanStore.connectorAccounts.find(
      (account) => account.accountId == accountNumber
    );
    if (connectorSearch) {
      setAccountFound({ ...connectorSearch, type: "c" });
      return;
    }
    setAccountFound(null);
    if(!connectorSearch&&!serviceSearch){
      NotifyError(General?.codeLabels['cm_pdc_paymentaccountnot']?.label?General?.codeLabels['cm_pdc_paymentaccountnot']?.label:'Account Does Not Exist')
    }
  };

  const handleAddAccount = (account: Obj) => {
    if (account.type == "s") {
      delete account.type;
      PaymentPlanStore.addServiceAccounts(account);
      handleAddAccountClose();
    } else {
      delete account.type;
      PaymentPlanStore.addConnectorAccounts(account);
      handleAddAccountClose();
    }
  };

  const handleConfirmAndSubmit = async (totalAmount: string) => {
    //validate total amount greater than minimum
    await PaymentPlanStore.validateAmount({
      errorId: "validateAmountError",
      data: totalAmount,
    });

    if (PaymentPlanStore.amountValidation.isTotalAmountValid != null) {
      console.log(
        "***PaymentPlanStore.amountValidation:",
        PaymentPlanStore.amountValidation
      );
      if (PaymentPlanStore.amountValidation.isTotalAmountValid) {
        setValue(3);
      } else {
        //error: A minimum of ${minAmountRequired} is required
        ErrorSubscription.subscribe({
          message: `A minimum of ${PaymentPlanStore.amountValidation.minAmountRequired} AED is required`,
          id: "validateAmountError",
        });
      }
    }
  };
    const [planLoader,setPlanLoader]=useState(false);
  const handleCalculatePaymentPlan = async () => {
    setPlanLoader(true);
    const data = {
      personId: User.info.personId as string,
    };
    
    await PaymentPlanStore.calculatePaymentPlan({
      errorId: "calculatePaymentPlanError",
      data,
    });
    setPlanLoader(false);
  };

  const handleCreatePaymentPlan = async (data: any,files: Array<File>) => {
    const fullData = {
      ...data,
      personId: User.info.personId,
      personName: User.info.userName, //TODO: azdon el username walla el name min el profile
    };
   console.log(data)
    // setValue(4)
    setSubmitLoader(true)
    PaymentPlanStore.createPaymentPlan({
      errorId: "createPaymentPlanError",
      data: fullData,
    }).then((res) => {
      if (res?.result?.output?.status == "S") {
        setCaseID(res?.result?.output?.caseId);
        handleUploadDocuments(files,res?.result?.output?.caseId)
        setValue(4);
        setSubmitLoader(false);
      }
    });
    
  };

  const handleUploadDocuments = async (files:any,caseNo:any) => {
    console.log("caseNo", caseNo);
    const upData = {
      caseNo,
    };
    // const upData={"caseNo":"4223521127"}
    const formData = new FormData();
    formData.append("data", JSON.stringify(upData));
    for (let i = 0; i < files.length; i++) {
      formData.append("multiFileUpload", files[i]);
    }

    await PaymentPlanStore.uploadPDCDocuments({
      errorId: "uploadPDCDocumentsError",
      data: formData,
    });
  };

  // const GetSummary = async()=>{
  //   const data = {
  //     personId: User.info.personId as string
  //   }
  //   await PaymentPlanStore.getAllPDCs({errorId: 'getAllPDCsError', data})
  // }

  useEffect(() => {
    ErrorSubscription.unSubscribeAll();
    getServiceAccounts();
    getConnectorAccounts()
  }, []);
  const navigate = useNavigate();
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      style={{
        backgroundColor: contrast?.contrastBackground
          ? contrast?.contrastBackground
          : "",
      }}
    >
      <MoveInHeader
       style={{
        color: General.contrast.contrastColor
          ? General.contrast.contrastColor
          : '#fff',
        background: General.contrast.contrastBackground
          ? General.contrast.contrastBackground
          : ColorAss === '#101E8E'? '#62aa51': General?.ColorAss
      }}
        // className="DynamicBgColorTree"
       
      >
        <div>
          <MiniNav>
            <ButtonSecondary
               style={{

                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: "0",
                color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : 'rgba(98, 170, 81, 1)',
              }}
              onClick={() =>
                navigate("/dashboard")
              }
            >
              {General?.codeLabels["cm_back"]?.label !== undefined
                ? General?.codeLabels["cm_back"]?.label
                : "BACK"}
            </ButtonSecondary>
        {  User?.info?.personId&&  <ButtonSecondary
             style={{
              color: contrast?.contrastBackground ? contrast?.contrastBackground : "#fff", background: contrast?.contrastColor ? contrast?.contrastColor : 'rgba(98, 170, 81, 1)',
              width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
              height: "30px",
              border: "1px solid #FFF",
              fontSize: `${General.accessibility.fontSize}rem`,
              zIndex: "0"
            }}
              onClick={() => navigate("/dashboard")}
            >
           {General?.codeLabels["cm_dashboard"]?.label?General?.codeLabels["cm_dashboard"]?.label:' DASHBOARD'}
            </ButtonSecondary>}
          </MiniNav>
          <h1
          style={{
            fontFamily: "Segoe UI",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize:General?.isLargeScreen? `${3.1 * General.accessibility.fontSize}rem`:`${2*General.accessibility.fontSize}rem`,
            margin: "0",
            color: contrast?.contrastColor ? contrast?.contrastColor: "" ,
          }}
          >
            {General?.codeLabels["cm_request_for_plan"]?.label?General?.codeLabels["cm_request_for_plan"]?.label:' Request For Payment Plan'}
          </h1>
        </div>
      </MoveInHeader>
      <ComplaintContainer
        style={{
          backgroundColor:value === 4 ?"#eeeeee": contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
            width:General?.isLargeScreen?'':'100%'
        }}
      >
        <Box
          sx={{
            width:General?.isLargeScreen? "90%":"100%",
            padding:General?.isLargeScreen? "46px":"",
          }}
        >
          {value !== 4 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{ alignSelf: "flex-end", width: "100vw" }}
                variant="scrollable"
                // scrollButtons
                allowScrollButtonsMobile

              >
                <Tab
                  label={
                    <TabWithCount count="1" value={value}>
                   {General?.isLargeScreen&&   <span
                        style={{
                          fontSize: `${
                            0.88 * General.accessibility.fontSize
                          }rem`,
                          textTransform:'capitalize',
                          color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                        }}
                      >
                        {General?.codeLabels["cm_add_service"]?.label?General?.codeLabels["cm_add_service"]?.label:'Add Services Account'}
                      </span>}
                    </TabWithCount>
                  }
                  className="mui-move-in abc123"
                  {...a11yProps(0)}
                  sx={{
                    width: "25%",
                    minWidth: "23.5%",
                   background:General?.isLargeScreen? contrast?.contrastColor?contrast?.contrastColor: "#e7e9f8":"",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      :General?.ColorAss?General?.ColorAss: "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 1 ? false : true}
                />
                <Tab
                  label={
                    <TabWithCount count="2" value={value} fontSize="0.74rem">
                     {General?.isLargeScreen&& <span
                        style={{
                          fontSize: `${
                            0.88 * General.accessibility.fontSize
                          }rem`,
                          textTransform:'capitalize',
                          color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                        }}
                      >
                       {General?.codeLabels["cm_add_service_fee"]?.label?General?.codeLabels["cm_add_service_fee"]?.label:'Add Connection-Free Plots'}
                      </span>}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(1)}
                  sx={{
                    width: "24%",
                    minWidth: "23.5%",
                   background:General?.isLargeScreen? contrast?.contrastColor?contrast?.contrastColor: "#e7e9f8":"",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      :General?.ColorAss?General?.ColorAss: "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 2 ? false : true}
                />
                <Tab
                  label={
                    <TabWithCount count="3" value={value}>
                      {General?.isLargeScreen&& <span
                        style={{
                          fontSize: `${
                            0.88 * General.accessibility.fontSize
                          }rem`,
                          textTransform:'capitalize',
                          color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                        }}
                      >
                        {General?.codeLabels["cm_pdc_paymentaccountsummary"]
                          ?.label !== undefined
                          ? General?.codeLabels["cm_pdc_paymentaccountsummary"]
                              ?.label
                          : "Summary"}
                      </span>}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(2)}
                  sx={{
                    width: "24%",
                    minWidth: "23.5%",
                   background:General?.isLargeScreen? contrast?.contrastColor?contrast?.contrastColor: "#e7e9f8":"",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      :General?.ColorAss?General?.ColorAss: "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 3 ? false : true}
                />
                <Tab
                  label={
                    <TabWithCount count="4" value={value}>
                     {General?.isLargeScreen&& <span
                        style={{
                          fontSize: `${
                            0.88 * General.accessibility.fontSize
                          }rem`,
                          textTransform:'capitalize',
                          color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss,
                        }}
                      >
                        {General?.codeLabels["cm_plan_detail"]?.label?General?.codeLabels["cm_plan_detail"]?.label:'Plan Details'}
                      </span>}
                    </TabWithCount>
                  }
                  className="mui-move-in"
                  {...a11yProps(3)}
                  sx={{
                    width: "24%",
                    minWidth: "23.5%",
                   background:General?.isLargeScreen? contrast?.contrastColor?contrast?.contrastColor: "#e7e9f8":"",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      :General?.ColorAss?General?.ColorAss: "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    zIndex: "0",
                    alignItems: "start",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 4 ? false : true}
                />
               
              </Tabs>
            </Box>
          )}

          <TabPanel value={value} index={0}>
            <ServiceAccounts
              GetServiceAccounts={getServiceAccounts}
              serviceAccounts={PaymentPlanStore.serviceAccounts}
              addAccount={handleAddServiceAccount}
              removeAccount={handleRemoveServiceAccount}
              Next={() => {
                PaymentPlanStore.resetPlan()
                setValue(value + 1);
              }}
              setinputValue={setinputValue}
              serviceLoader={serviceLoader}
            />
          </TabPanel>
          <TabPanel value={value} index={1} width={"100%"}>
            <ConnectionFreePlots
              GetConnectorAccounts={getConnectorAccounts}
              connectorAccounts={PaymentPlanStore.connectorAccounts}
              addAccount={handleAddConnectorAccount}
              removeAccount={handleRemoveConnectorAccount}
              Next={() => setValue(value + 1)}
              Previous={() => {
                setValue(value - 1);
                ErrorSubscription.unSubscribeAll();
              }}
              setinputValue={setinputValue}
              inputValue={inputValue}
              connectorLoader={connectorLoader}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Summary
              openAddAccountModal={handleOpenAddAccountModal}
              // GetSummary={GetSummary}
              selectedServiceAccounts={PaymentPlanStore.selectedServiceAccounts}
              selectedConnectorAccounts={
                PaymentPlanStore.selectedConnectorAccounts
              }
              calculatePaymentPlan={handleCalculatePaymentPlan}
              confirmAndSubmit={handleConfirmAndSubmit}
              removeConnectorAccount={handleRemoveConnectorAccount}
              removeServiceAccount={handleRemoveServiceAccount}
              Next={() => setValue(value + 1)}
              Previous={() => {
                ErrorSubscription.unSubscribeAll();
                setValue(value - 1);
              }}
              planLoader={planLoader}
            />
          </TabPanel>
          <TabPanel value={value} index={3} padding={3}>
            <PlanDetails
              calculatedPlan={PaymentPlanStore.calculatedPlan}
              Next={() => setValue(value + 1)}
              Previous={() => {
                setValue(value - 1);
                ErrorSubscription.unSubscribeAll();
              }}
              validateMakani={handleValidateMakani}
              makaniValidation={General.makani}
              // calculatePaymentPlan={handleCalculatePaymentPlan}
              createPaymentPlan={handleCreatePaymentPlan}
              createdPlan={PaymentPlanStore.plan}
              // uploadDocuments={handleUploadDocuments}
              submitLoader={submitLoader}
            />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Thankyou
              title="Request"
              msg="Case ID"
              serviceID={21}
              referenceId={CaseID}
            />
          </TabPanel>
        </Box>
      </ComplaintContainer>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openAddAccount}
      >
        {
          <AccountPopup
            onCloseClick={handleAddAccountClose}
            searchClicked={handleSearchAccountNumber}
            account={accountFound}
            addAccount={handleAddAccount}
          />
        }
      </Backdrop>
    </div>
  );
};

export default observer(PaymentPlan);
